module.exports = __webpack_public_path__ + "media/Icons/veh_pictures-574bfd8f.svg";